import { Link } from "@/components/lib";
import ghsLogo from "@/images/grapevine_football_transparent.png";

type LogoProps = {
  color?: boolean;
  mark?: boolean;
  className?: string;
};

export function Logo(props: LogoProps) {
  return (
    <Link url="/" className={props.className}>
      <img src={ghsLogo} alt="Logo" />
    </Link>
  );
}
